import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

var ReactDOM = require('react-dom')

export class PopUpInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            superbombaRewards: null,
            superbombaReward: null,
            superbombaRewardInfo: null,
            superbombaError: false,
            superBombaGameIntroInfo: null,
            superBombaIntroLoaded: false,
            showCategories: true,
            showProviders: true,
            showThemes: true,
            showHistoryFilter: false,
            activeHistoryFilter: null,
            showSpecialFilters: true,
            closeProgressWidth: 215,
            closeDuration: 5000,
            providerShowAll: false,
            visibleCount: 100,
            brojDostupnihBomba: 0,
            dodatnaProvjeraRef: null
        }

        // Create a div that we'll render the modal into. Because each
        // Modal component has its own element, we can render multiple
        // modal components into the modal container.
        this.el = document.createElement('div');
        this.prekiniBonus = this.prekiniBonus.bind(this);
        this.getSuperbombaReward = this.getSuperbombaReward.bind(this);
        this.confirmFilter = this.confirmFilter.bind(this);
        this.getSortedBrandKeys = this.getSortedBrandKeys.bind(this);
    }

    componentDidMount() {
        // Append the element into the DOM on mount. We'll render
        // into the modal container element (see the HTML tab).
        document.getElementById('modal').appendChild(this.el);
    }

    componentWillUnmount() {
        // Remove the element from the DOM when we unmount
        document.getElementById('modal').removeChild(this.el);
    }

    componentDidUpdate(prevProps) {
        if (this.props.popUpCode !== prevProps.popUpCode) {
            if (this.props.popUpCode == "prihvatiSamoZaMeneBonus" || this.props.popUpCode == 'infoAktivanBonus' || this.props.popUpCode == 'casino-superbomba')
                this.props.disablePopUpOutsideClickFn();

            if (this.props.popUpCode == "casino-superkisa-notification") {
                this.closeProgressTimer();
            }
        }

        if (this.props.popUpCode == 'casino-superbomba' && this.props.popUpParams && this.props.popUpParams.baseData?.brojDostupnihBomba != prevProps.popUpParams?.baseData?.brojDostupnihBomba) {
            this.setState({ brojDostupnihBomba: this.props.popUpParams.baseData.brojDostupnihBomba });
            const intervalId = setInterval(() => {
                casino.repos.casinoSuperbombaProvjeraRepo.get(this.props.popUpParams.baseData.sifra).then((result) => {
                    if (result && result.id > 0) {
                        this.setState({ brojDostupnihBomba: result.brojDostupnihBomba })
                    }

                });
            }, 2000);

            this.setState({ dodatnaProvjeraRef: intervalId });
        }
    }

    prekiniBonus() {
        this.props.showLoadingFn(true)

        var that = this;
        var promocija = this.props.user.promocije.runningItems.filter(x => x.active && (x.jePrewager || x.poker))[0];

        casino.repos.promotionRepo.remove(promocija).then(x => {
            that.props.fetchUserFn().then(x => {
                that.props.showLoadingFn(false);
                that.props.showPopUpFn(false);
            })
        })
    }

    prekiniPonudu() {
        this.props.showLoadingFn(true)

        var that = this;
        var promocija = this.props.user.promocije.availableItems[0];

        casino.repos.prewagerPonudaRepo.remove(promocija).then(x => {
            that.props.fetchUserFn().then(x => {
                that.props.showLoadingFn(false);
                that.props.showPopUpFn(false);
            })
        })
    }

    getSuperbombaReward(redniBroj) {
        clearTimeout(this.state.dodatnaProvjeraRef);
        casino.repos.casinoSuperbombaNagradaRepo.get(this.props.popUpParams.baseData.id, redniBroj, this.state.brojDostupnihBomba, this.props.popUpParams.baseData.sifra).then((res) => {
            this.setState({ superbombaRewards: res, superbombaReward: res.find(it => it.odabranaBomba), visibleCount: 100 });
            setTimeout(() => this.setState({ superbombaRewardInfo: true }), 0);
            setTimeout(() => this.setState({ superbombaRewardInfo: false }), 5000);
            setTimeout(() => {
                let rew = [];
                this.state.superbombaRewards.forEach(x => {
                    x['prikazi'] = true;
                    rew.push(x);
                });
                this.setState({ superbombaRewards: rew });
            }, 5500);

        }).catch(() => {
            this.setState({ superbombaError: true });
            setTimeout(() => this.setState({ superbombaError: false }), 5000);
        });
    }

    closeSuperbombaModal(sifra) {
        this.props.showPopUpFn(false);
        clearTimeout(this.state.dodatnaProvjeraRef);
        this.setState({ superbombaRewards: null, superbombaRewardInfo: null, superbombaReward: null, visibleCount: 100, dodatnaProvjeraRef: null });

        //pokreni ponovno ping
        setTimeout(() => this.superBombaProvjera(sifra), 5000);
    }

    superBombaProvjera(sifra) {
        casino.repos.casinoSuperbombaProvjeraRepo.get(sifra).then((result) => {
            if (result && result.id > 0) {
                casino.config.showPopUpFromOutside(true, 'casino-superbomba', null, { baseData: result });
            } else {
                setTimeout(() => this.superBombaProvjera(sifra), 5000);
            }
        });
    }

    selectCategory(category) {
        this.setState({ activeHistoryFilter: null });
        this.props.setActiveFiltersFn(
            this.props.filterSelectedCategories.find(it => it.id == category.id) != null ? this.props.filterSelectedCategories.filter(it => it.id != category.id) : [...this.props.filterSelectedCategories, category],
            this.props.filterSelectedProviders,
            this.props.filterSelectedThemes,
            this.props.filterSelectedSpecialFilters);
        setTimeout(() => this.props.filterGamesFn(this.props.popUpParams.games), 0);
    }

    selectTheme(theme) {
        this.setState({ activeHistoryFilter: null });
        this.props.setActiveFiltersFn(
            this.props.filterSelectedCategories,
            this.props.filterSelectedProviders,
            this.props.filterSelectedThemes.find(it => it.sifra == theme.sifra) != null ? this.props.filterSelectedThemes.filter(it => it.sifra != theme.sifra) : [...this.props.filterSelectedThemes, theme],
            this.props.filterSelectedSpecialFilters);
        setTimeout(() => this.props.filterGamesFn(this.props.popUpParams.games), 0);
    }

    selectProvider(providerID) {
        this.setState({ activeHistoryFilter: null });
        this.props.setActiveFiltersFn(
            this.props.filterSelectedCategories,
            this.props.filterSelectedProviders.find(it => it == providerID) != null ? this.props.filterSelectedProviders.filter(it => it != providerID) : [...this.props.filterSelectedProviders, providerID],
            this.props.filterSelectedThemes,
            this.props.filterSelectedSpecialFilters);
        setTimeout(() => this.props.filterGamesFn(this.props.popUpParams.games), 0);
    }

    selectSpecialFilter(type) {
        this.setState({ activeHistoryFilter: null });
        this.props.setActiveFiltersFn(
            this.props.filterSelectedCategories,
            this.props.filterSelectedProviders,
            this.props.filterSelectedThemes,
            this.props.filterSelectedSpecialFilters.find(it => it == type) != null ? this.props.filterSelectedSpecialFilters.filter(it => it != type) : [...this.props.filterSelectedSpecialFilters, type]);
        setTimeout(() => this.props.filterGamesFn(this.props.popUpParams.games), 0);
    }

    closeFilterModal(clear) {
        if (clear) {
            this.props.setActiveFiltersFn([], [], [], []);
            setTimeout(() => this.props.filterGamesFn(), 0);
        }
        this.props.pupUpCallback();
        this.props.showPopUpFn(false);
    }

    confirmFilter() {
        if (this.props.filteredGames.length > 0) {
            var now = new Date();
            let save = {
                categories: this.props.filterSelectedCategories.map(it => it.id),
                providers: this.props.filterSelectedProviders,
                themes: this.props.filterSelectedThemes.map(it => it.sifra),
                specialFilters: this.props.filterSelectedSpecialFilters,
                date: now.toLocaleString("hr-HR")
            };

            var storedFilters = JSON.parse(localStorage.getItem("stored-filters"));

            if (!storedFilters) {
                storedFilters = [save]
            } else {
                let add = true;
                storedFilters.every(item => {
                    if (JSON.stringify(item.categories) === JSON.stringify(save.categories) &&
                        JSON.stringify(item.providers) === JSON.stringify(save.providers) &&
                        JSON.stringify(item.themes) === JSON.stringify(save.themes) &&
                        JSON.stringify(item.specialFilters) === JSON.stringify(save.specialFilters)) {
                        add = false;
                        return false;
                    } else {
                        return true;
                    }
                });

                if (add) storedFilters.unshift(save);
            }
            if (storedFilters.length > 6) storedFilters.length = 6;

            localStorage.setItem("stored-filters", JSON.stringify(storedFilters));
            this.props.setHistoryFiltersFn(storedFilters);
            this.closeFilterModal(false);
        }
    }

    setHistoryFilters(history) {
        this.props.setActiveFiltersFn(
            history.categories.length > 0 ? this.props.popUpParams.categories.filter(it => history.categories.filter(x => x == it.id).length > 0) : [],
            history.providers.length > 0 ? Object.keys(this.props.popUpParams.brands).filter(it => history.providers.filter(x => x == it).length > 0) : [],
            history.themes.length > 0 ? this.props.popUpParams.themes.filter(it => history.themes.filter(x => x == it.sifra).length > 0) : []
        );
        this.setState({ activeHistoryFilter: history.date });
        setTimeout(() => {
            this.props.filterGamesFn(this.props.popUpParams.games);
            this.forceUpdate();
        }, 0);
    }

    toggleHistory() {
        try {
            let sectionsElem = document.getElementById("sections");
            this.setState({ showHistoryFilter: !this.state.showHistoryFilter }, () => {
                if (this.state.showHistoryFilter) {
                    let box = document.querySelector('.filter-history');
                    let height = box.offsetHeight + 20;
                    sectionsElem.style.height = 'calc(60vh - ' + height + 'px)';
                } else {
                    sectionsElem.style.height = '60vh';
                }
            });
        }
        catch (e) {
            this.setState({ showHistoryFilter: !this.state.showHistoryFilter });
        }
    }

    getSortedBrandKeys() {
        let brands = this.props.popUpParams.brands;
        // Sort brands with specific providers first, then the rest alphabetically
        const topProviderOrder = ["amusnet", "egt-digital", "pragmaticplay", "playn-go", "greentube"];

        // Get keys sorted in the desired order
        const sortedBrandKeys = Object.keys(brands).sort((a, b) => {
            const brandA = brands[a].nameNormalizirano;
            const brandB = brands[b].nameNormalizirano;

            // Check if either brand is in the priority list
            const indexA = topProviderOrder.indexOf(brandA);
            const indexB = topProviderOrder.indexOf(brandB);

            // If both are in the priority list, sort by their order in that list
            if (indexA !== -1 && indexB !== -1) {
                return indexA - indexB;
            }

            // If only A is in the priority list, it comes first
            if (indexA !== -1) {
                return -1;
            }

            // If only B is in the priority list, it comes first
            if (indexB !== -1) {
                return 1;
            }

            // If neither is in the priority list, sort alphabetically
            return brandA.localeCompare(brandB);
        });

        return sortedBrandKeys;
    }

    renderHomepageFilter() {
        let sortedBrandKeys = this.props.popUpParams?.brands ? this.getSortedBrandKeys() : null;
        return ReactDOM.createPortal(
            <div className={"popUp homepage-filter-popup" + (this.props.showPopUp ? ' active' : '')} >
                <div className="clearfix popUp-header">
                    <h2>Filtriraj</h2>
                    <span className="clear-filter" onClick={() => {
                        this.props.setActiveFiltersFn([], [], [], []);
                        setTimeout(() => {
                            this.props.filterGamesFn();
                            this.forceUpdate();
                            this.setState({ activeHistoryFilter: null });
                        }, 0);
                    }}>
                    </span>
                    {this.props.historyFilters.filter(it => it.date != null).length > 0 && <span className="history-text" onClick={() => this.toggleHistory()} >Povijest</span>}
                    <a className="pull-right link link-1 active" aria-current="true" onClick={() => {
                        this.props.setActiveFiltersFn([], [], []);
                        setTimeout(() => {
                            this.props.filterGamesFn();
                            this.setState({ activeHistoryFilter: null });
                            this.forceUpdate();
                            this.closeFilterModal(true);
                        }, 0)
                    }}>
                        <span className="close-icon icon ico-close-thin"></span>
                    </a>
                    {this.state.showHistoryFilter && <>
                        <div className="filter-history">
                            {this.props.historyFilters.length > 0 && this.props.historyFilters.filter(it => it.date != null).slice(0, 3).map((history, index) => {
                                return <div className={"history-item " + (this.state.activeHistoryFilter == history.date ? "selected" : "")} onClick={() => this.setHistoryFilters(history)} key={"history" + index}>{history.date}</div>
                            })}
                        </div>
                    </>}
                </div>
                <div className="popUpBody">
                    <div className="divider"></div>
                    <div className="sections" id="sections">
                        <div className="section">
                            <h3 onClick={() => this.setState({ showProviders: !this.state.showProviders })}>Provideri</h3>
                            <span className={"arrow " + (!this.state.showProviders ? "rotate" : "")} onClick={() => this.setState({ showProviders: !this.state.showProviders })}></span>
                            {this.state.showProviders && <div className="content two-columns">
                                {sortedBrandKeys && (this.state.providerShowAll ? sortedBrandKeys : sortedBrandKeys.slice(0, 5)).map((key, index) => {
                                    return <div onClick={() => this.selectProvider(key)}
                                        className={(this.props.filterSelectedProviders?.filter(it => it == key).length == 1 ? "selected filter-provider p_" : "filter-provider p_") + casino.utils.normalizeString(this.props.popUpParams.brands[key].name)}
                                        key={"provider" + index}></div>

                                })}
                                {sortedBrandKeys && sortedBrandKeys.length > 5 &&
                                    <div
                                        onClick={() => this.setState({ providerShowAll: !this.state.providerShowAll })}
                                        className="provider-show-more">
                                        {this.state.providerShowAll ? "Prikaži manje" : "Prikaži više"}
                                        <span className={"show-more-img " + (this.state.providerShowAll ? "up" : "down")}></span>
                                    </div>
                                }
                            </div>}
                        </div>
                        <div className="divider in-section"></div>
                        <div className="section">
                            <h3 onClick={() => this.setState({ showThemes: !this.state.showThemes })}>Teme</h3>
                            <span className={"arrow " + (!this.state.showThemes ? "rotate" : "")} onClick={() => this.setState({ showThemes: !this.state.showThemes })}></span>
                            {this.state.showThemes && <div className="content two-columns">
                                {this.props.popUpParams && this.props.popUpParams.themes.map((theme, index) => {
                                    return <div onClick={() => this.selectTheme(theme)}
                                        className={(this.props.filterSelectedThemes?.filter(it => it.sifra == theme.sifra).length == 1 ? "selected theme " : "theme ") + casino.utils.normalizeString(theme.naziv)}
                                        key={"theme" + index}>{theme.naziv}</div>

                                })}
                            </div>}
                        </div>
                        <div className="divider in-section"></div>
                        <div className="section">
                            <h3 onClick={() => this.setState({ showSpecialFilters: !this.state.showSpecialFilters })}>Odabrano</h3>
                            <span className={"arrow " + (!this.state.showSpecialFilters ? "rotate" : "")} onClick={() => this.setState({ showSpecialFilters: !this.state.showSpecialFilters })}></span>
                            {this.state.showSpecialFilters && <div className="content two-columns">
                                {this.props.user && this.props.user.zadnjeIgrano.length > 0 && <div onClick={() => this.selectSpecialFilter(1)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 1).length == 1 ? "moje-zadnje-odigrano selected" : "moje-zadnje-odigrano")}>{casino.utils.getFilterOdabranoName(1)}
                                </div>}
                                {this.props.user && this.props.user.najigranije.length > 0 && <div onClick={() => this.selectSpecialFilter(2)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 2).length == 1 ? "moje-najomiljenije selected" : "moje-najomiljenije")}>{casino.utils.getFilterOdabranoName(2)}
                                </div>}
                                <div onClick={() => this.selectSpecialFilter(3)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 3).length == 1 ? "selected eksluzivno" : "eksluzivno")}>{casino.utils.getFilterOdabranoName(3)}
                                </div>
                                <div onClick={() => this.selectSpecialFilter(4)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 4).length == 1 ? "selected najnovije" : "najnovije")}>{casino.utils.getFilterOdabranoName(4)}
                                </div>
                                {this.props.popUpParams?.games.filter(game => game.p && game.p.indexOf("re") != -1).length > 0 && (<div onClick={() => this.selectSpecialFilter(5)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 5).length == 1 ? "selected respin" : "respin")}>{casino.utils.getFilterOdabranoName(5)}
                                </div>)}
                                {this.props.popUpParams?.games.filter(game => game.p && game.p.indexOf("mw") != -1).length > 0 && (<div onClick={() => this.selectSpecialFilter(6)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 6).length == 1 ? "selected megaways" : "megaways")}>{casino.utils.getFilterOdabranoName(6)}
                                </div>)}
                                {this.props.popUpParams?.games.filter(game => game.p && game.p.indexOf("bb") != -1).length > 0 && (<div onClick={() => this.selectSpecialFilter(7)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 7).length == 1 ? "selected bonus-buy" : "bonus-buy")}>{casino.utils.getFilterOdabranoName(7)}
                                </div>)}
                                {this.props.popUpParams?.games.filter(game => game.p && game.p.indexOf("haw") != -1).length > 0 && (<div onClick={() => this.selectSpecialFilter(8)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 8).length == 1 ? "selected hold-and-win" : "hold-and-win")}>{casino.utils.getFilterOdabranoName(8)}
                                </div>)}
                                {this.props.popUpParams?.games.filter(game => game.p && game.p.indexOf("jc") != -1).length > 0 && (<div onClick={() => this.selectSpecialFilter(9)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 9).length == 1 ? "selected jackpot-cards" : "jackpot-cards")}>{casino.utils.getFilterOdabranoName(9)}
                                </div>)}
                                {this.props.popUpParams?.games.filter(game => game.p && game.p.indexOf("bl") != -1).length > 0 && (<div onClick={() => this.selectSpecialFilter(10)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 10).length == 1 ? "selected bell-link" : "bell-link")}>{casino.utils.getFilterOdabranoName(10)}
                                </div>)}
                                {this.props.popUpParams?.games.filter(game => game.p && game.p.indexOf("gcl") != -1).length > 0 && (<div onClick={() => this.selectSpecialFilter(11)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 11).length == 1 ? "selected golden-coins-link-filter" : "golden-coins-link-filter")}>{casino.utils.getFilterOdabranoName(11)}
                                </div>)}
                                {this.props.popUpParams?.games.filter(game => game.p && game.p.indexOf("br") != -1).length > 0 && (<div onClick={() => this.selectSpecialFilter(12)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 12).length == 1 ? "selected barlink" : "barlink")}>{casino.utils.getFilterOdabranoName(12)}
                                </div>)}
                                {this.props.popUpParams?.games.filter(game => game.p && game.p.indexOf("jr") != -1).length > 0 && (<div onClick={() => this.selectSpecialFilter(13)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 13).length == 1 ? "selected jackpot-rain-filter" : "jackpot-rain-filter")}>{casino.utils.getFilterOdabranoName(13)}
                                </div>)}
                                {this.props.popUpParams?.games.filter(game => game.p && game.p.indexOf("eq") != -1).length > 0 && (<div onClick={() => this.selectSpecialFilter(14)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 14).length == 1 ? "selected egypt-quest" : "egypt-quest")}>{casino.utils.getFilterOdabranoName(14)}
                                </div>)}
                                {this.props.popUpParams?.games.filter(game => game.p && game.p.indexOf("gnb") != -1).length > 0 && (<div onClick={() => this.selectSpecialFilter(15)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 15).length == 1 ? "selected golden-nights-bonus" : "golden-nights-bonus")}>{casino.utils.getFilterOdabranoName(15)}
                                </div>)}
                                {this.props.popUpParams?.games.filter(game => game.p && game.p.indexOf("rhfp") != -1).length > 0 && (<div onClick={() => this.selectSpecialFilter(16)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 16).length == 1 ? "selected red-hot-fire-pot" : "red-hot-fire-pot")}>{casino.utils.getFilterOdabranoName(16)}
                                </div>)}
                                {this.props.popUpParams?.games.filter(game => game.p && game.p.indexOf("gj") != -1).length > 0 && (<div onClick={() => this.selectSpecialFilter(17)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 17).length == 1 ? "selected gameart-jackpot" : "gameart-jackpot")}>{casino.utils.getFilterOdabranoName(17)}
                                </div>)}
                                {this.props.popUpParams?.games.filter(game => game.p && game.p.indexOf("cc") != -1).length > 0 && (<div onClick={() => this.selectSpecialFilter(18)}
                                    className={(this.props.filterSelectedSpecialFilters?.filter(it => it == 18).length == 1 ? "selected clover-chance" : "clover-chance")}>{casino.utils.getFilterOdabranoName(18)}
                                </div>)}
                            </div>}
                        </div>
                        <div className="divider in-section"></div>
                        <div className="section">
                            <h3 onClick={() => this.setState({ showCategories: !this.state.showCategories })}>Kategorije</h3>
                            <span className={"arrow " + (!this.state.showCategories ? "rotate" : "")} onClick={() => this.setState({ showCategories: !this.state.showCategories })}></span>
                            {<div className="content two-columns">
                                {this.state.showCategories && this.props.popUpParams && this.props.popUpParams.categories.map((category, index) => {
                                    return category.aktivno ? <div onClick={() => this.selectCategory(category)}
                                        className={(this.props.filterSelectedCategories?.filter(it => it.id == category.id).length == 1 ? "selected " : "") + casino.utils.normalizeString(category.name)}
                                        key={"category" + index}>{category.name}</div> : null
                                })}
                            </div>}
                        </div>
                    </div>
                    <div className="divider"></div>
                </div>
                <div className="popUp-footer">
                    <div onClick={() => this.confirmFilter()}
                        className={"confirm-filter-btn " + (this.props.filteredGames.length == 0 ? "disabled" : "")}>Prikaži ({this.props.filteredGames.length})</div>
                </div>
            </div>,
            this.el);
    }

    renderCouponActivated() {
        return ReactDOM.createPortal(
            <div className={"popUp coupon-activated-popup homepage-filter-popup" + (this.props.showPopUp ? ' active' : '')} >
                <div className="clearfix popUp-header">
                    <h3 >Kupon je aktiviran</h3>
                    <a className="pull-right link link-1 active" aria-current="true" onClick={() => {
                        this.props.showPopUpFn(false)
                    }}><span className="close-icon icon ico-close-thin"></span></a>
                </div>
                <div className="popUpBody">
                    <div className="img-coupon"></div>

                    <p className="coupon-info">Čestitamo! Uspješno si aktivirao kupon <strong>"{this.props.popUpParams?.code}"</strong>!</p>
                    <br></br><br></br>
                    <div className="text-center">
                        <button className="btn medium fill" onClick={() => this.props.showPopUpFn(false)}>
                            <span>OK, Zatvori</span>
                        </button>
                    </div>
                    <br></br>

                </div>
            </div>,
            this.el);
    }

    closeProgressTimer(x = this.state.closeDuration) {
        this.setState({ closeProgressWidth: 215 * (x / this.state.closeDuration) });

        if (x >= 0) {
            requestAnimationFrame(() => this.closeProgressTimer(x - 10));
        } else {
            this.props.showPopUpFn(false);
        }
    }

    renderSuperkisaNotification() {
        let result = this.props?.popUpParams?.result;

        return ReactDOM.createPortal(
            <div className={"popUp casinoSuperkisaNotificationPopUp" + (this.props.showPopUp ? ' active' : '')} >
                <div className="in-game-notification">
                    <div className="ig-content">
                        <div className="ig-close-icon icon ico-close" onClick={() => this.closeProgressTimer(-1)}></div>
                        <div className="ig-icon">
                            {result?.superKisaVrstaID == 1 && <img src={"content/images/notifications/nagrada-" + result?.nagradaVrstaID + ".png"} />}
                            {result?.superKisaVrstaID == 2 && <img src={"content/images/notifications/nagrada-poklon.png"} />}
                        </div>
                        <div className="ig-text">
                            <div>{result?.superKisaVrstaID == 1 ? "Pala je SuperKiša!" : "Pao je SuperPoklon!"}</div>
                            <div>{result?.nagrada}</div>
                            <div className="ig-progress-bar" style={{ width: this.state.closeProgressWidth }}></div>
                        </div>
                    </div>
                </div>
            </div>,
            this.el);
    }

    handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        const totalBombs = this.state.brojDostupnihBomba || 0;

        // Ako smo pri dnu (unutar 50px)
        if (scrollHeight - scrollTop <= clientHeight + 50) {
            if (this.state.visibleCount < totalBombs) {
                this.setState((prevState) => ({
                    visibleCount: prevState.visibleCount + 100
                }));
            }
        }
    }

    render() {

        if (this.props.popUpCode == "infoAktivanBonus") {

            return ReactDOM.createPortal(
                <div className={"popUp prekiniBonusPopUp" + (this.props.showPopUp ? ' active' : '')} >
                    <div className="clearfix popUp-header">
                        <span >Imate aktivan bonus!</span>
                        <a className="pull-right link link-1 active" aria-current="true" onClick={() => {
                            this.props.showPopUpFn(false)
                        }}><span className="close-icon icon ico-close-thin"></span></a>
                    </div>
                    <div className="popUpBody">
                        <div className="icon-bonus" />

                        <br></br>
                        Za prihvat nove promocije, molimo da prekinete ili završite trenutno aktivan bonus.<br></br>
                        <br></br><br></br>
                        <div className="text-center">
                            <button className="btn medium fill" onClick={() => this.props.showPopUpFn(false)}>
                                <span>Zatvori</span>
                            </button>
                        </div>
                        <br></br>

                    </div>
                </div>,
                this.el);
        }

        if (this.props.popUpCode == "prihvatiSamoZaMeneBonus") {
            return ReactDOM.createPortal(
                <div className={"popUp prekiniBonusPopUp" + (this.props.showPopUp ? ' active' : '')} >
                    <div className="clearfix popUp-header">
                        <span >Ponuda je aktivirana</span>
                        <a className="pull-right link link-1 active" aria-current="true" onClick={() => {
                            this.props.showPopUpFn(false)
                        }}><span onClick={this.props.pupUpCallback} className="close-icon icon ico-close-thin"></span></a>
                    </div>
                    <div className="popUpBody">
                        <br></br>
                        <div className="icon-bonus" />
                        <p className="popUp-text">
                            Čestitamo! Uspješno si aktivirao ponudu. <br></br>Nastavi u igru, želimo ti sreću!
                        </p>
                        {this.props.popUpParams && this.props.popUpParams.freespinBrojSpinova > 0 && <p className="popUp-text">Da bi ostvarili besplatne vrtnje, molimo vas da pokrenete igru</p>}
                        <div className="text-center">
                            {!this.props.disablePopUpBtn && <button className="btn red" onClick={this.props.pupUpCallback}>
                                <span>OK, NASTAVI</span>
                            </button>}
                            {/*{this.props.disablePopUpBtn && <button className="gray btn medium fill">*/}
                            {/*    <span>Prihvati bonus</span>*/}
                            {/*</button>}*/}
                            {/*<span>{' '}</span>*/}
                            {/*<button className="blue btn medium fill" onClick={() => this.props.showPopUpFn(false)}>*/}
                            {/*    <span>Odustani</span>*/}
                            {/*</button>*/}
                        </div>
                        <br></br>

                    </div>
                </div>,
                this.el);
        }

        if (this.props.popUpCode == "ponudaNijeAkrivirana") {
            return ReactDOM.createPortal(
                <div className={"popUp prekiniBonusPopUp" + (this.props.showPopUp ? ' active' : '')} >
                    <div className="clearfix popUp-header">
                        <span>Ponuda nije aktivirana</span>
                        <a className="pull-right link link-1 active" aria-current="true" onClick={() => {
                            this.props.showPopUpFn(false)
                        }}><span onClick={this.props.pupUpCallback} className="close-icon icon ico-close-thin"></span></a>
                    </div>
                    <div className="popUpBody">
                        <br></br>
                        <div className="icon-bonus" />
                        <p className="popUp-text">
                            Došlo je do pogreške, molimo pokušajte ponovno.
                        </p>
                    </div>
                </div>,
                this.el);

        }


        if (this.props.popUpCode == "igraNaOdrzavanju") {

            return ReactDOM.createPortal(
                <div className={"popUp prekiniBonusPopUp" + (this.props.showPopUp ? ' active' : '')} >
                    <div className="clearfix popUp-header">
                        <span >Igra na održavanju</span>
                        <a className="pull-right link link-1 active" aria-current="true" onClick={() => {
                            this.props.showPopUpFn(false)
                        }}><span className="close-icon icon ico-close-thin"></span></a>
                    </div>
                    <div className="popUpBody">
                        <div className="icon-bonus" />

                        <br></br>
                        Igra je trenutno na održavanju, molimo pokušajte kasnije<br></br>
                        <br></br><br></br>
                        <div className="text-center">
                            <button className="btn medium fill" onClick={() => this.props.showPopUpFn(false)}>
                                <span>Zatvori</span>
                            </button>
                        </div>
                        <br></br>

                    </div>
                </div>,
                this.el);
        }

        if (this.props.popUpCode == "prekiniBonus" || this.props.popUpCode == "prekiniPonudu") {

            var iznos = 0;
            var jePoker = false;
            this.props.user && this.props.user.promocije.runningItems.length && this.props.user.promocije.runningItems.map(x => {
                if (x.jePrewager && x.active)
                    iznos = x.prekidIznos;

                if (x.poker)
                    jePoker = true;
            })

            return ReactDOM.createPortal(
                <div className={"popUp prekiniBonusPopUp" + (this.props.showPopUp ? ' active' : '')} >

                    <div className="clearfix popUp-header">
                        <span >Prekini bounus?</span>
                        <a className="pull-right link link-1 active" aria-current="true" onClick={() => {
                            this.props.showPopUpFn(false)
                        }}><span className="close-icon icon ico-close-thin"></span></a>
                    </div>
                    <div className="popUpBody">
                        Jeste li sigurni da želite prekinuti bonus?<br></br>
                        {this.props.popUpCode == "prekiniBonus" && !jePoker && <span>Izgubit ćete <span className="text-bold" style={{ color: '#e62031' }} > {iznos + (casino.config.guiValuta == 'EUR' ? ' €' : ' kn')}  </span> bonusa!</span>}
                        <br /><br />
                        <div className="icon-bonus" />
                        <br />
                        Prekinuti bonus ne možete vratiti!
                        <br /><br />
                        <div className="text-center">
                            <button className="btn medium fill" onClick={() => this.props.popUpCode == "prekiniBonus" ? this.prekiniBonus() : this.prekiniPonudu()}>
                                <span>Prekini bonus</span>
                            </button>
                            <span>{' '}</span>
                            <button className="btn medium fill" onClick={() => this.props.showPopUpFn(false)}>
                                <span>Odustani</span>
                            </button>
                        </div>
                        <br></br>

                    </div>
                </div>,
                this.el);

        }


        if (this.props.user && this.props.user.promocije.availableItems && this.props.user.promocije.availableItems.length > 0) {
            var reloadPromotion = this.props.user.promocije.availableItems[0];
            var promotionCode = reloadPromotion.kod + '--' + reloadPromotion.id;
            if (reloadPromotion.kod && reloadPromotion.kod.indexOf('CasinoReload') == 0) {



                {
                    // hudo rjesenje
                    if (!window.localStorage.getItem(promotionCode))
                        setTimeout(() => {
                            this.props.showPopUpFn(true, promotionCode);
                        }, 100);
                }


                return ReactDOM.createPortal(
                    <div className={"popUp casinoReload" + (this.props.showPopUp ? ' active' : '')} >

                        <div className="clearfix popUp-header">
                            <span ></span>
                            <a className="pull-right link link-1 active" aria-current="true" onClick={() => {
                                this.props.showPopUpFn(false)
                            }}><span className="close-icon icon ico-close-thin"></span></a>
                        </div>
                        <img src="content/images/bonusi/casinoreload/img_banner_dialog.jpg" ></img>
                        <div className="popUpBody">
                            Želiš li ekskluzivni bonus?
                            Prilikom uplate odaberi „Želim Casino reload bonus“ i osvoji do <span style={{ color: '#b05a1b' }}>{casino.utils.numberToString(reloadPromotion.maxDeposit)} kuna </span> bonusa!
                            Požuri, ponuda traje do {casino.utils.dateToFullDateString(new Date(reloadPromotion.datumZavrsetka))} u {casino.utils.dateToTimeString(new Date(reloadPromotion.datumZavrsetka))} sati.
                            <br></br><br></br>
                            Bonus možete iskoristiti samo jednom
                            <br></br><br></br>
                            <NavLink to='/reload' activeClassName="selected" className="reload-button" onClick={() => this.props.showPopUpFn(false)}>
                                <span>Želim bonus</span>
                            </NavLink>
                            <br></br>
                        </div>
                    </div>,
                    this.el);


            }
        }

        if (this.props.popUpCode == "casino-superbomba") {

            const totalBombs = this.state.brojDostupnihBomba || 0;
            const currentVisible = Math.min(this.state.visibleCount, totalBombs);

            return ReactDOM.createPortal(
                <div className={"popUp casinoSuperbombaPopUp" + (this.props.showPopUp ? ' active' : '')} >
                    <a className="close-btn" aria-current="true" onClick={() => { this.closeSuperbombaModal(this.props.popUpParams.baseData.sifra) }}><span className="close-icon icon ico-close-thin"></span></a>
                    <div className="wrapper">
                        {this.state.superbombaError &&
                            <div className="error">
                                <img className="front" src="content/images/bonusi/casinosuperbomba/sad.png"></img> Dogodila se greška, molimo pokušajte kasnije!
                            </div>}
                        {!this.state.superbombaRewardInfo && <div>
                            {this.state.superbombaReward && <div className="title">Osvojio si SuperBomba nagradu!</div>}
                            {!this.state.superbombaReward && <>
                                <div className="title">Čestitamo, korak si do nagrade!</div>
                                <div className="subtitle">Odaberi i otkrij jednu neosvojenu bombu, te osvoji nagradu. </div>
                            </>}

                            <div className="bombs" onScroll={this.handleScroll}>

                                {this.props.popUpParams && this.props.popUpParams.baseData && !this.state.superbombaRewards && Array.apply(null, { length: currentVisible }).map((e, i) => (
                                    <div className="bomb" key={i} onClick={() => this.getSuperbombaReward((i + 1))}>
                                        <img className="full-bomb" src="content/images/bonusi/casinosuperbomba/img_bomba.png"></img>
                                        <div className="reward"></div>
                                        <div className="simbol-naziv"></div>
                                    </div>
                                ))}

                                {this.state.superbombaRewards && this.state.superbombaRewards.slice(0, this.state.visibleCount).map((rew, i) => (
                                    <div className={"bomb final " + (rew.odabranaBomba || rew.prikazi ? 'exploded' : '')} key={i}>
                                        <img className="front" src="content/images/bonusi/casinosuperbomba/eksplozija/front.png"></img>
                                        <img className="back" src="content/images/bonusi/casinosuperbomba/eksplozija/back.png"></img>
                                        <img className="smoke" src="content/images/bonusi/casinosuperbomba/eksplozija/smoke.png"></img>
                                        <img className="parts" src="content/images/bonusi/casinosuperbomba/eksplozija/parts.png"></img>
                                        <img className="simbol" src={`content/images/bonusi/casinosuperbomba/simboli/${rew.bombaCode}.png`}></img>
                                        <img className="full-bomb final" src="content/images/bonusi/casinosuperbomba/img_bomba.png"></img>
                                        {rew.odabranaBomba && <img className="checkmark" src="content/images/bonusi/casinosuperbomba/icon-checkmark_green.png"></img>}
                                        <div className="reward">{rew.odabranaBomba || rew.prikazi ? (casino.utils.numberWithCurrencyFromated(rew.nagrada, rew.valuta)) : ''}</div>
                                        <div className="simbol-naziv">{rew.odabranaBomba || rew.prikazi ? rew.bomba : ''}</div>
                                    </div>
                                ))}
                            </div>
                        </div>}
                        {this.state.superbombaRewardInfo && <div>
                            <div className="title">Osvojio si SuperBomba nagradu!</div>
                            <div className="bombs">
                                <div className="bomb final exploded single">
                                    <img className="front" src="content/images/bonusi/casinosuperbomba/eksplozija/front_x2.png"></img>
                                    <img className="back" src="content/images/bonusi/casinosuperbomba/eksplozija/back_x2.png"></img>
                                    <img className="smoke" src="content/images/bonusi/casinosuperbomba/eksplozija/smoke.png"></img>
                                    <img className="parts" src="content/images/bonusi/casinosuperbomba/eksplozija/parts.png"></img>
                                    <img className="simbol" src={`content/images/bonusi/casinosuperbomba/simboli/${this.state.superbombaReward.bombaCode}_x2.png`}></img>
                                    <img className="checkmark" src="content/images/bonusi/casinosuperbomba/icon-checkmark_green.png"></img>
                                    <div className="reward">{(casino.utils.numberWithCurrencyFromated(this.state.superbombaReward.nagrada, this.state.superbombaReward.valuta))}</div>
                                    <div className="simbol-naziv">{this.state.superbombaReward.bomba}</div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>,
                this.el);
        }

        if (this.props.popUpCode == "casino-superbomba-game-intro") {
            if (!this.state.superBombaIntroLoaded) {
                casino.repos.casinoSuperbombaGameIntroRepo.get(this.props.popUpParams.sifra).then(res => this.setState({ superBombaGameIntroInfo: res, superBombaIntroLoaded: true }));
                setTimeout(() => this.props.showPopUpFn(false), 3000);
            }

            return ReactDOM.createPortal(
                <div className={"popUp casinoSuperbombaGameIntroPopUp" + (this.props.showPopUp ? ' active' : '')} >
                    <a className="close-btn" aria-current="true" onClick={() => { this.props.showPopUpFn(false) }}><span className="close-icon icon ico-close-thin"></span></a>
                    <div className="info">
                        <div className="bomb exploded">
                            <img className="front" src="content/images/bonusi/casinosuperbomba/eksplozija/front.png" />
                            <img className="back" src="content/images/bonusi/casinosuperbomba/eksplozija/back.png" />
                            <img className="smoke" src="content/images/bonusi/casinosuperbomba/eksplozija/smoke.png" />
                            <img className="parts" src="content/images/bonusi/casinosuperbomba/eksplozija/parts.png" />
                            <img className="simbol" style={{ 'left': '0px' }} src="content/images/bonusi/casinosuperbomba/simboli/zlato.png" />
                        </div>
                        <div>
                            <div className="text-1">U Superbombi je ostalo još</div>
                            <div className="text-2"><span className="gold">{this.state.superBombaGameIntroInfo}</span> nagrada!</div>
                        </div>
                    </div>
                </div>,
                this.el);
        }

        if (this.props.popUpCode == "homepage-filter") {
            return this.renderHomepageFilter();
        }

        if (this.props.popUpCode == "coupon-activated") {
            return this.renderCouponActivated();
        }

        if (this.props.popUpCode == "casino-superkisa-notification") {
            return this.renderSuperkisaNotification();
        }

        // zbog animacija moramo vratiti div
        return ReactDOM.createPortal(
            <div className={"popUp " + (this.props.showPopUp ? ' active' : '')} >
            </div>,
            this.el);
    }
};
